import axios from 'axios';

const API_URL = 'https://api.tekteck.com';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Ajouter le token JWT automatiquement
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('tekteck_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Gerer les erreurs 401
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('tekteck_token');
      localStorage.removeItem('tekteck_user');
      window.location.href = '/connexion';
    }
    return Promise.reject(error);
  }
);

// AUTH
export const authAPI = {
  register: (data) => api.post('/api/auth/register', data),
  login: (data) => api.post('/api/auth/login', data),
  profil: () => api.get('/api/auth/profil'),
};

// ANNONCES
export const annoncesAPI = {
  getAll: (params) => api.get('/api/annonces', { params }),
  getOne: (id) => api.get(`/api/annonces/${id}`),
  create: (data) => api.post('/api/annonces', data),
  mesAnnonces: () => api.get('/api/annonces/vendeur/mes-annonces'),
  delete: (id) => api.delete(`/api/annonces/${id}`),
};

// COMMANDES
export const commandesAPI = {
  create: (data) => api.post('/api/commandes', data),
  mesCommandes: () => api.get('/api/commandes/mes-commandes'),
  commandesVendeur: () => api.get('/api/commandes/vendeur/recues'),
  updateStatut: (id, statut) => api.put(`/api/commandes/${id}/statut`, { statut }),
  confirmerReception: (id) => api.put(`/api/commandes/${id}/confirmer-reception`),
};

// UPLOAD
export const uploadAPI = {
  single: (image) => api.post('/api/upload', { image }),
  multiple: (images) => api.post('/api/upload/multiple', { images }),
};

// HELPERS
export const saveAuth = (token, user) => {
  localStorage.setItem('tekteck_token', token);
  localStorage.setItem('tekteck_user', JSON.stringify(user));
};

export const getUser = () => {
  const user = localStorage.getItem('tekteck_user');
  return user ? JSON.parse(user) : null;
};

export const getToken = () => localStorage.getItem('tekteck_token');

export const isLoggedIn = () => !!localStorage.getItem('tekteck_token');

export const logout = () => {
  localStorage.removeItem('tekteck_token');
  localStorage.removeItem('tekteck_user');
  window.location.href = '/connexion';
};
// ADMIN
export const adminAPI = {
  stats: () => api.get('/api/admin/stats'),
  commandes: (params) => api.get('/api/admin/commandes', { params }),
  vendeurs: (params) => api.get('/api/admin/vendeurs', { params }),
  updateVendeurStatut: (id, statut) => api.put(`/api/admin/vendeurs/${id}/statut`, { statut }),
  utilisateurs: () => api.get('/api/admin/utilisateurs'),
  updateRole: (id, role) => api.put(`/api/admin/utilisateurs/${id}/role`, { role }),
  annonces: () => api.get('/api/admin/annonces'),
  updateAnnonceStatut: (id, statut) => api.put(`/api/admin/annonces/${id}/statut`, { statut }),
  updateCommandeStatut: (id, statut) => api.put(`/api/admin/commandes/${id}/statut`, { statut }),
};
export default api;